module.exports = __webpack_public_path__ + "img/discount-tag.7811152.svg";